var l = Object.defineProperty,
  t = Object.getOwnPropertySymbols,
  p = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable,
  a = (r, e, o) => e in r ? l(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: o
  }) : r[e] = o,
  n = (r, e) => {
    for (var o in e || (e = {})) p.call(e, o) && a(r, o, e[o]);
    if (t) for (var o of t(e)) c.call(e, o) && a(r, o, e[o]);
    return r;
  };
const b = _ref => {
  let {
    color: r
  } = _ref;
  return n({}, r && {
    color: "var(".concat(r, ")")
  });
};
export { b as withColors };